// Manuscript Import
export const CLEAR_IMPORT_DATA = 'clearImportData';
export const SET_QUEUE_SEARCH_TEXT = 'setQueueSearchText';
export const SET_QUEUE_SORT = 'setQueueSort';
export const SET_GUID_IMPORT_TEXT = 'setGuidImportText';
export const REMOVE_IMPORT_ITEM = 'removeImportItem';
export const ADD_IMPORT_ITEMS = 'addImportItems';
export const UPDATE_IMPORT_ITEMS = 'updateImportItems';
export const UPDATE_AND_VALIDATE_IMPORT_ITEMS = 'updateAndValidateImportItems';
export const ADD_GUID_IMPORT_ITEMS = 'addGuidImportItems';
export const ADD_FILE_IMPORT_ITEMS = 'addFileImportItems';
export const ADD_IMPORT_ITEMS_TO_QUEUE = 'addImportItemsToQueue';
export const VALIDATE_IMPORT_ITEMS = 'validateImportItems';
export const GET_QUEUE_ITEMS = 'getQueueItems';
export const UPDATE_FLEX_BOXES = 'updateFlexBoxes';
export const START_QUEUE_ITEM_UPDATES = 'startQueueItemUpdates';
export const STOP_QUEUE_ITEM_UPDATES = 'stopQueueItemUpdates';
export const SET_QUEUE_ITEM_UPDATES_ENABLED = 'setQueueItemUpdatesEnabled';
export const SET_CONFIRM_NAVIGATE_DIALOG = 'setConfirmNavigateDialog';

// Manuscript Builder
export const SET_CONFIRM_TAB_NAVIGATION_DIALOG = 'setConfirmTabNavigationDialog';
export const SET_METADATA_HAS_UNSAVED_CHANGES = 'setMetadataHasUnsavedChanges';

// Manuscript Generate
export const GENERATE_STATUS_NOT_GENERATED = 'not-generated';
export const GENERATE_STATUS_GENERATING = 'generating';
export const GENERATE_STATUS_GENERATED = 'generated';
export const GENERATE_STATUS_REGENERATE_NEEDED = 'regenerate-needed';
export const GENERATE_STATUS_DISABLED = 'disabled';
export const GENERATE_STATUS_ERROR = 'error';

// Manuscript Export
export const TOGGLE_ALL_EXPORTS = 'toggleAllExports';
export const TOGGLE_EXPORT_ITEM = 'toggleExportItem';
export const DOWNLOAD_SELECTED_EXPORTS = 'downloadSelectedExports';
export const CLEAR_SELECTED_EXPORTS = 'clearSelectedExports';
export const MAX_SELECTED_EXPORTS = 50;

// Import Errors
export const ERROR_INVALID_GUID = 'ErrorInvalidGuid';
export const ERROR_INVALID_POINTER_GUID = 'ErrorInvalidPointerGuid';
export const ERROR_VALIDATION_FAILED = 'ErrorValidationFailed';
export const ERROR_INVALID_FILENAME = 'ErrorInvalidFilename';
export const ERROR_INVALID_FILE_EXTENSION = 'ErrorInvalidFileExtension';
export const ERROR_FAILED_TO_IMPORT = 'ErrorFailedToImport';

export const PREVENT_IMPORT_ERRORS = [
  ERROR_INVALID_GUID,
  ERROR_INVALID_POINTER_GUID,
  ERROR_VALIDATION_FAILED,
  ERROR_INVALID_FILENAME,
  ERROR_INVALID_FILE_EXTENSION,
];

export const GUID_IMPORT_ERRORS = [
  ERROR_INVALID_GUID,
  ERROR_INVALID_POINTER_GUID,
];

// Import/Export Queue
export const SORT_FIELD_NAME = 'title';
export const SORT_FIELD_UPLOADED_BY = 'creator';
export const SORT_FIELD_EXPORTED_BY = 'creator';
export const SORT_FIELD_DATE_ADDED = 'created_on';
export const SORT_FIELD_DATE_EXPORTED = 'created_on';
export const SORT_FIELD_STATUS = 'status';
export const SORT_FIELD_IMPORT_STATUS = 'import_status';
export const SORT_FIELD_EXPORT_TYPE = 'export_type';

export const QUEUE_ITEM_STATUS_COMPLETE = 'complete';
export const QUEUE_ITEM_STATUS_QUEUED = 'queued';
export const QUEUE_ITEM_STATUS_ERROR = 'error';
export const QUEUE_ITEM_STATUS_PROCESSING = 'processing';
export const QUEUE_ITEM_STATUS_EXPIRED = 'expired';

export const QUEUE_ITEM_UPDATE_INTERVAL = 15000;

export const EXPORT_QUEUE_TYPE_MAPPING = {
  word: '.docx',
};

// Manuscript
export const MAXIMUM_SELECTABLE_MANUSCRIPTS = 50;
export const CLEAR_MANUSCRIPT = 'clearManuscript';
export const DELETE_MANUSCRIPT = 'deleteManuscript';
export const PATCH_MANUSCRIPT = 'patchManuscript';
export const POST_EXPORTS = 'postExports';
export const POST_MANUSCRIPT = 'postManuscript';
export const GET_MANUSCRIPT_PRODUCT_CONFIG = 'getManuscriptProductConfig';
export const GET_MANUSCRIPT = 'getManuscript';
export const GET_MANUSCRIPTS = 'getManuscripts';
export const GET_MANUSCRIPT_USERS = 'getManuscriptUsers';
export const GENERATE_LESSON = 'generateLesson';
export const GENERATE_PAGE = 'generatePage';
export const FETCH_DRAFT_FOR_PREVIEW = 'fetchDraftForPreview';

export const SET_CURRENT_PAGE = 'setCurrentPage';
export const SET_FILTER_BY_SEARCH_TEXT = 'setFilterBySearchText';
export const SET_FILTER_BY_ASSIGNEE_IDS = 'setFilterByAssigneeIds';
export const SET_FILTER_BY_PROJECT_IDS = 'setFilterByProjectIds';
export const SET_FILTER_BY_STATUSES = 'setFilterByStatuses';
export const SET_FILTER_BY_UNASSIGNED = 'setFilterByUnassigned';
export const SET_MANUSCRIPTS_PER_PAGE = 'setManuscriptsPerPage';
export const SET_SELECTED_MANUSCRIPT_IDS = 'setSelectedManuscriptIds';
export const SET_SORT_BY = 'setSortBy';
export const SET_SORT_DIRECTION = 'setSortDirection';
export const SET_INITIAL_SEARCH_PARAMS = 'setInitialSearchParams';

export const UPDATE_USERS_ASSIGNED_A_COLOR = 'updateUsersAssignedAColor';
export const RESET_ALL_FILTERS = 'resetAllFilters';
export const UNASSIGN_VALUE = 'unassign';

// Project
export const GET_PROJECTS = 'getProjects';

// Product Config
export const GET_PRODUCT_CONFIG = 'getProductConfig';
export const RESET_PRODUCT_CONFIG = 'resetProductConfig';

// Users
export const GET_USERS = 'getUsers';

// Toast Messages
export const ADD_TOAST_MESSAGE = 'addToastMessage';
export const REMOVE_TOAST_MESSAGE = 'removeToastMessage';
